﻿'use strict';
import Axios from 'axios';
import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
const plugins = [CSSPlugin, ScrollToPlugin];


export default class SignupModal {

    constructor() {

        if (!d.querySelector("#signupModal")) {
            return;
        }


        const HideRegModal = () => {
            TweenLite.to(d.querySelector("#signupModal"), .5, {
                alpha: 0,
                onComplete: () => {
                    d.querySelector("body").classList.remove("modal-open");
                    d.querySelector("#signupModal").style.display = "";
                }
            });
            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'pyc_modal_hide', {
                    'modal_name': d.querySelector(".innerModal .header").innerText
                });
            }
        }
        const ShowRegModal = () => {

            if (!window.grecaptcha) {
                var sc = document.createElement("script");
                sc.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq");
                d.querySelector("#signupModal").appendChild(sc);

                //https://www.google.com/recaptcha/api.js?render=6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq
            }


            d.querySelector("#signupModal").style.display = "block";
            TweenLite.set(d.querySelector("#signupModal"), { opacity: 0 });
            TweenLite.to(d.querySelector("#signupModal"), .5, {
                opacity: 1, onComplete: () => {
                    d.querySelector("body").classList.add("modal-open");

                    d.querySelector("#RegistrationName").value = "";
                    d.querySelector("#RegistrationName").classList.remove("error");

                    d.querySelector("#RegistrationEmail").value = "";
                    d.querySelector("#RegistrationEmail").classList.remove("error");

                    d.querySelector("#RegistrationLastName").value = "";
                    d.querySelector("#RegistrationLastName").classList.remove("error");

                    d.querySelector(".agreeContainer").classList.remove("error");
                    d.querySelector(".agreeContainer input").checked = false;

                    d.querySelector("#RegisterClassBtn").classList.remove("disabled");



                }
            });
        }

        const ProcessRegistrationCancel = (classId, cancelId, email) => {

            d.querySelector("#CancelRegisterClassBtn").classList.add("disabled");

            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'pyc_modal_cancel', {
                    'modal_name': d.querySelector(".innerModal .header").innerText
                });
            }
            Axios.post("/api/pyc/CancelRegistration", {
                "ClassId": classId,
                "CancelId": cancelId,
                "Email": email
            }).then((result) => {
                if (result.data == false) {
                    //show error message
                    d.querySelector("#CancelErrors").style.display = "block";
                } else {
                    // go to confirmation message
                    d.querySelector(".innerModal__unregister .innerModal__form").style.display = "none";
                    d.querySelector(".innerModal__unregister .confirmation").style.display = "block";
                }
                d.querySelector("#CancelRegisterClassBtn").classList.remove("disabled");
            });
        }

        this.OpenRegModalXHR = (orgId, classId) => {
            Axios.get(`/community/ClassCard/${classId}`).then((result) => {
                const element = document.createRange().createContextualFragment(result.data);

                d.querySelector("#RegistrationClassId").value = classId;
                d.querySelector("#RegistrationOrganizationId").value = orgId;
                d.querySelector("#AddToCalendar").setAttribute("href", "/community/addtocalendar/" + classId);

                var image = element.querySelector("picture").outerHTML;
                var bottomText = element.querySelector(".card-bottom").innerHTML;
                d.querySelector("#signupModal .innerModal__top").innerHTML = image;


                d.querySelector("#signupModal .dynamic").innerHTML = bottomText;

                if (d.querySelector("#signupModal .dynamic .more_info")) {
                    d.querySelector("#signupModal .dynamic .more_info").remove();
                }
                d.querySelector("#signupModal .agreeContainer").style.display = "";

                d.querySelectorAll("#signupModal .formItem").forEach((item) => {
                    item.style.display = "";
                });

                d.querySelectorAll("#signupModal .resultItem").forEach((item) => {
                    item.style.display = "none";
                });

                ShowRegModal();
            });
        }

        this.OpenUnregisterModal = (classId, unregisterCode) => {
            Axios.get(`/community/ClassCard/${classId}`).then((result) => {
                const element = document.createRange().createContextualFragment(result.data);

                d.querySelector("#CancelRegisterClassBtn").addEventListener("click", (e) => {
                    ProcessRegistrationCancel(classId, unregisterCode, d.querySelector("#CancelRegistrationEmail").value);
                });

                var image = element.querySelector("picture").outerHTML;
                var bottomText = element.querySelector(".card-bottom").innerHTML;
                var link = element.querySelector(".more_info");
                var orgId = link.dataset.organizationid;

                d.querySelector("#signupModal .innerModal__top").innerHTML = image;
                d.querySelector("#signupModal .dynamic").innerHTML = bottomText;

                if (d.querySelector("#signupModal .dynamic .more_info")) {
                    d.querySelector("#signupModal .dynamic .more_info").remove();
                }
                d.querySelector("#signupModal .agreeContainer").style.display = "";

                d.querySelectorAll("#signupModal .formItem").forEach((item) => {
                    item.style.display = "";
                });

                d.querySelectorAll("#signupModal .resultItem").forEach((item) => {
                    item.style.display = "none";
                });

                d.querySelector("#signupModal .innerModal__form").style.display = "none";
                d.querySelector("#signupModal .innerModal__unregister").style.display = "block";
                d.querySelector("#CancelErrors").style.display = "none";
                d.querySelector(".innerModal__unregister .innerModal__form").style.display = "block";
                d.querySelector(".innerModal__unregister .confirmation").style.display = "none";

                if (window.hasOwnProperty("gtag")) {
                    gtag('event', 'pyc_modal_cancel_open', {
                        'modal_name': d.querySelector(".innerModal .header").innerText
                    });
                }

                ShowRegModal();


                try {
                    const PYCHub = $.connection.pYCHub;
                    //console.log("starting hub");
                    $.connection.hub.start().done(function () {
                        PYCHub.server.refreshPage(orgId);
                        // console.log("refreshing page:: ", orgId);
                    });

                } catch (e) {

                }


            });
        };

        this.OpenRegModal = (orgId, classId, element) => {




            d.querySelector("#RegistrationClassId").value = classId;
            d.querySelector("#RegistrationOrganizationId").value = orgId;
            d.querySelector("#AddToCalendar").setAttribute("href", "/community/addtocalendar/" + classId);

            var image = element.querySelector("picture").outerHTML;
            var bottomText = element.querySelector(".card-bottom").innerHTML;
            d.querySelector("#signupModal .innerModal__top").innerHTML = image;


            d.querySelector("#signupModal .dynamic").innerHTML = bottomText;

            if (d.querySelector("#signupModal .dynamic .more_info")) {
                d.querySelector("#signupModal .dynamic .more_info").remove();
            }

            d.querySelector("#signupModal .agreeContainer").style.display = "";

            d.querySelectorAll("#signupModal .formItem").forEach((item) => {
                item.style.display = "";
            });
            
            d.querySelectorAll("#signupModal .resultItem").forEach((item) => {
                item.style.display = "none";
            });

            if (window.hasOwnProperty("gtag")) {
                gtag('event', 'modal_open', {
                    'modal_name': d.querySelector(".innerModal .header").innerText
                });
            }
            ShowRegModal();
        }

        d.querySelector("#RegisterClassBtn").addEventListener("click", (e) => {
            var classId = parseInt(d.querySelector("#RegistrationClassId").value);
            var orgId = parseInt(d.querySelector("#RegistrationOrganizationId").value);
            var name = d.querySelector("#RegistrationName").value;
            var lastName = d.querySelector("#RegistrationLastName").value;
            var email = d.querySelector("#RegistrationEmail").value;
            var agreeCheck = d.querySelector("#agreeCheck").checked;

            e.currentTarget.classList.add("disabled");
            d.querySelector("#registrationErrors").innerHTML = "";
            d.querySelector("#registrationErrors").style.display = "";
            var isValid = true;

            if (!name) {
                isValid = false;
                d.querySelector("#RegistrationName").classList.add("error");
            }
            
            if (!lastName) {
                isValid = false;
                d.querySelector("#RegistrationLastName").classList.add("error");
            }

            if (!email || !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
                isValid = false;
                d.querySelector("#RegistrationEmail").classList.add("error");
            }

            //if (!agreeCheck) {
            //    isValid = false;
            //    d.querySelector(".agreeContainer").classList.add("error");
            //}

            if (isValid) {
                if (window.hasOwnProperty("gtag")) {
                    gtag('event', 'pyc_modal_registration', {
                        'modal_name': d.querySelector(".innerModal .header").innerText
                    });
                }
                grecaptcha.ready(function () {
                    grecaptcha.execute('6LdDWSQkAAAAAJ29aJlFYvPyIx1xRkmmd8P4kmoq', { action: 'submit' }).then(function (token) {
                        

                        Axios.post("/api/pyc/RegisterClass", {
                            "ClassId": classId,
                            "OrganizationId": orgId,
                            "Name": name,
                            "LastName": lastName,
                            "Email": email,
                            "OptIn": agreeCheck,
                            "recaptcharesponse": token
                        }).then((result) => {

                            var errors = result.data;

                            if (errors.length > 0) {
                                d.querySelector("#RegisterClassBtn").classList.remove("disabled");

                                var errorDivs = "";
                                errors.forEach((item) => {
                                    errorDivs += `<div class="error">${item}</div>`;
                                });
                                d.querySelector("#registrationErrors").innerHTML = errorDivs;
                                d.querySelector("#registrationErrors").style.display = "block";

                                TweenLite.delayedCall(5, () => {
                                    d.querySelector("#registrationErrors").style.display = "none";
                                    d.querySelector("#registrationErrors").innerHTML = "";
                                });


                            } else {

                                d.querySelector("#signupModal .header").innerText = "You're Signed up for " + d.querySelector("#signupModal .header").innerText;

                                d.querySelector("#signupModal .agreeContainer").style.display = "none";

                                d.querySelectorAll("#signupModal .formItem").forEach((item) => {
                                    item.style.display = "none";
                                });

                                d.querySelectorAll("#signupModal .resultItem").forEach((item) => {
                                    item.style.display = "";
                                });

                                try {
                                    const PYCHub = $.connection.pYCHub;

                                    console.log("starting hub:: ");
                                    $.connection.hub.start().done(function () {
                                        PYCHub.server.refreshPage(orgId);
                                        console.log("refreshing page:: ", orgId);
                                    });
                                } catch (e) {

                                }
                            }
                        });

                    });
                });


            } else {
                e.currentTarget.classList.remove("disabled");
            }
            
        });


        d.querySelector("#RegistrationName").addEventListener("blur", (e) => {
            if (d.querySelector("#RegistrationName").classList.contains("error")) {
                if (d.querySelector("#RegistrationName").value) {
                    d.querySelector("#RegistrationName").classList.remove("error");
                }
            }
        });
        d.querySelector("#RegistrationLastName").addEventListener("blur", (e) => {
            if (d.querySelector("#RegistrationLastName").classList.contains("error")) {
                if (d.querySelector("#RegistrationLastName").value) {
                    d.querySelector("#RegistrationLastName").classList.remove("error");
                }
            }
        });
        d.querySelector("#RegistrationEmail").addEventListener("blur", (e) => {
            if (d.querySelector("#RegistrationEmail").classList.contains("error")) {
                var email = d.querySelector("#RegistrationEmail").value;
                if (email && /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
                    d.querySelector("#RegistrationEmail").classList.remove("error");
                }
            }
        });


        d.querySelector("#signupModal .curtain").addEventListener("click", (e) => {
            HideRegModal();
        });

    }
}